export interface ChatParticipantInfo {
  profilId: number;
  imie: string;
  nazwisko: string;
  aktywnosc: number;
}

export interface ChatConversation {
  id: number;
  isGroup: boolean;
  name: string;
  participants: ChatParticipantInfo[];
  unreadCount: number;
  lastMessage: { body: string | null; deleted: boolean; authorId: number; createdAt: string } | null;
  hasInactiveParticipant: boolean;
}

export interface ChatMessage {
  id: number;
  conversationId: number;
  authorId: number;
  body: string | null;
  deleted: boolean;
  createdAt: string;
  editedAt: string | null;
  editable: boolean;
  deletable: boolean;
}

export interface ChatBadge {
  total: number;
  chats: number;
  notifications: number;
  /** Nieobsluzone powiadomienia specjalne (requiresAck) - do pulsowania dzwonka w stanie
   *  zamknietym, niezaleznie od tego, czy lista powiadomien byla juz wczytana w tej sesji. */
  pendingAck: number;
}

/** "Powiadomienia" - dane to profil_messages, patrz ChatService.notifications() w backendzie. */
export interface ChatNotification {
  id: number;
  profilId: number;
  title: string;
  body: string;
  link: string | null;
  source: string | null;
  sourceId: number | null;
  createdBy: number;
  createdAt: string;
  readAt: string | null;
  requiresAck: boolean;
  ackAt: string | null;
}

/** Id "rozmowy" powiadomien w UI - nie ma prawdziwej konwersacji w bazie, jest stala, ujemna,
 *  zeby na pewno nie kolidowala z prawdziwym id z chat_conversations (auto_increment > 0). */
export const NOTIFICATIONS_CONVERSATION_ID = -1;

export type ChatIconKind = 'notifications' | 'direct' | 'group';
